module.exports = __webpack_public_path__ + "media/images/front/sp/default/noimage_s800x424-39687e5a72824a0618f2c17924b9f4d9.png";